import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PasscodeTokenService {
  readonly keyPrefix = 'quote_passcode_token:';

  getToken(portalLink: string) {
    try {
      return localStorage.getItem(this.storageKey(portalLink));
    } catch (error: unknown) {
      return null;
    }
  }

  setToken(portalLink: string, token: string) {
    try {
      localStorage.setItem(this.storageKey(portalLink), token);
    } catch (error: unknown) {
      console.log(error);
    }
  }

  clearToken(portalLink: string) {
    try {
      localStorage.removeItem(this.storageKey(portalLink));
    } catch (error: unknown) {
      console.log(error);
    }
  }

  storageKey(portalLink: string) {
    return `${this.keyPrefix}${portalLink}`;
  }
}
